__turbopack_context__.v({
  "backdrop": "page-module__aARuMq__backdrop",
  "badge": "page-module__aARuMq__badge",
  "buttons": "page-module__aARuMq__buttons",
  "contentWrapper": "page-module__aARuMq__contentWrapper",
  "description": "page-module__aARuMq__description",
  "destinationLabel": "page-module__aARuMq__destinationLabel",
  "disclaimer": "page-module__aARuMq__disclaimer",
  "header": "page-module__aARuMq__header",
  "icon": "page-module__aARuMq__icon",
  "leavingContainer": "page-module__aARuMq__leavingContainer",
  "leavingPage": "page-module__aARuMq__leavingPage",
  "link": "page-module__aARuMq__link",
  "linkWrapper": "page-module__aARuMq__linkWrapper",
  "logo": "page-module__aARuMq__logo",
  "main": "page-module__aARuMq__main",
  "mediaFoxHighlight": "page-module__aARuMq__mediaFoxHighlight",
  "spacer": "page-module__aARuMq__spacer",
  "timer": "page-module__aARuMq__timer",
  "timerCancelButton": "page-module__aARuMq__timerCancelButton",
  "timerCanceled": "page-module__aARuMq__timerCanceled",
  "timerCopy": "page-module__aARuMq__timerCopy",
  "timerDescription": "page-module__aARuMq__timerDescription",
  "timerDisabled": "page-module__aARuMq__timerDisabled",
  "timerDisabledIcon": "page-module__aARuMq__timerDisabledIcon",
  "timerLabel": "page-module__aARuMq__timerLabel",
  "timerProgress": "page-module__aARuMq__timerProgress",
  "timerSeconds": "page-module__aARuMq__timerSeconds",
  "title": "page-module__aARuMq__title",
  "url": "page-module__aARuMq__url",
  "visuallyHidden": "page-module__aARuMq__visuallyHidden",
});
